// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading-container {
  --background: var(--ion-color-primary-contrast);
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
}

.loading-content {
  text-align: center;
  padding: 2rem;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.loading-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 400px;
}
.loading-section .logo-container {
  margin-bottom: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.loading-section .logo-container img {
  width: 200px;
  height: 200px;
  max-width: 200px;
  max-height: 200px;
  background: transparent;
  display: block;
  object-fit: contain;
}
.loading-section .logo-container .logo-fade {
  animation: fadeInOut 2s ease-in-out infinite;
}
.loading-section .loading-text {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 2rem;
}
.loading-section .loading-text h2 {
  color: var(--ion-color-primary);
  font-weight: bold;
  font-size: 1.3rem;
  margin: 0;
}
.loading-section .loading-text .loading-status {
  color: var(--ion-color-medium);
  font-size: 1switfhem;
  margin: 0;
  font-weight: 600;
  min-height: 1.5rem;
}
.loading-section .progress-container {
  width: 100%;
  max-width: 300px;
  margin-top: 1rem;
}
.loading-section .progress-container ion-progress-bar {
  --progress-background: #ed143d;
  height: 4px;
  border-radius: 2px;
}

.error-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 400px;
}
.error-section .logo-container {
  margin-bottom: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.error-section .logo-container img {
  width: 200px;
  height: 200px;
  max-width: 200px;
  max-height: 200px;
  background: transparent;
  opacity: 0.7;
  display: block;
  object-fit: contain;
}
.error-section .error-text {
  margin-bottom: 2rem;
  text-align: center;
}
.error-section .error-text h2 {
  color: var(--ion-color-danger);
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0 0 0.5rem 0;
}
.error-section .error-text p {
  color: var(--ion-color-medium);
  font-size: 1rem;
  margin: 0;
  line-height: 1.5;
}
.error-section .error-actions ion-button {
  --border-radius: 8px;
  font-weight: 600;
  min-width: 120px;
}

@keyframes fadeInOut {
  0%, 100% {
    opacity: 0.3;
  }
  50% {
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/app-loading/app-loading.component.scss"],"names":[],"mappings":"AAAA;EACE,+CAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AACF;;AAEA;EACE,kBAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;AAAF;AAEE;EACE,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAAJ;AAEI;EACE,YAAA;EACA,aAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,cAAA;EACA,mBAAA;AAAN;AAGI;EACE,4CAAA;AADN;AAKE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;AAHJ;AAKI;EACE,+BAAA;EACA,iBAAA;EACA,iBAAA;EACA,SAAA;AAHN;AAMI;EACE,8BAAA;EACA,oBAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;AAJN;AAQE;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;AANJ;AAQI;EACE,8BAAA;EACA,WAAA;EACA,kBAAA;AANN;;AAYA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;AATF;AAWE;EACE,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AATJ;AAWI;EACE,YAAA;EACA,aAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;AATN;AAaE;EACE,mBAAA;EACA,kBAAA;AAXJ;AAaI;EACE,8BAAA;EACA,iBAAA;EACA,gBAAA;EACA,oBAAA;AAXN;AAcI;EACE,8BAAA;EACA,eAAA;EACA,SAAA;EACA,gBAAA;AAZN;AAiBI;EACE,oBAAA;EACA,gBAAA;EACA,gBAAA;AAfN;;AAqBA;EACE;IACE,YAAA;EAlBF;EAoBA;IACE,UAAA;EAlBF;AACF","sourcesContent":[".loading-container {\n  --background: var(--ion-color-primary-contrast);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 100vh;\n}\n\n.loading-content {\n  text-align: center;\n  padding: 2rem;\n  height: 100%;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n// Loading State Styles\n.loading-section {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  max-width: 400px;\n\n  .logo-container {\n    margin-bottom: 2rem;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    img {\n      width: 200px;\n      height: 200px;\n      max-width: 200px;\n      max-height: 200px;\n      background: transparent;\n      display: block;\n      object-fit: contain;\n    }\n\n    .logo-fade {\n      animation: fadeInOut 2s ease-in-out infinite;\n    }\n  }\n\n  .loading-text {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 0.75rem;\n    margin-bottom: 2rem;\n    \n    h2 {\n      color: var(--ion-color-primary);\n      font-weight: bold;\n      font-size: 1.3rem;\n      margin: 0;\n    }\n\n    .loading-status {\n      color: var(--ion-color-medium);\n      font-size: 1switfhem;\n      margin: 0;\n      font-weight: 600;\n      min-height: 1.5rem;\n    }\n  }\n\n  .progress-container {\n    width: 100%;\n    max-width: 300px;\n    margin-top: 1rem;\n\n    ion-progress-bar {\n      --progress-background: #ed143d;\n      height: 4px;\n      border-radius: 2px;\n    }\n  }\n}\n\n// Error State Styles\n.error-section {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  max-width: 400px;\n\n  .logo-container {\n    margin-bottom: 2rem;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    img {\n      width: 200px;\n      height: 200px;\n      max-width: 200px;\n      max-height: 200px;\n      background: transparent;\n      opacity: 0.7;\n      display: block;\n      object-fit: contain;\n    }\n  }\n\n  .error-text {\n    margin-bottom: 2rem;\n    text-align: center;\n\n    h2 {\n      color: var(--ion-color-danger);\n      font-size: 1.5rem;\n      font-weight: 600;\n      margin: 0 0 0.5rem 0;\n    }\n\n    p {\n      color: var(--ion-color-medium);\n      font-size: 1rem;\n      margin: 0;\n      line-height: 1.5;\n    }\n  }\n\n  .error-actions {\n    ion-button {\n      --border-radius: 8px;\n      font-weight: 600;\n      min-width: 120px;\n    }\n  }\n}\n\n// Animations\n@keyframes fadeInOut {\n  0%, 100% {\n    opacity: 0.3;\n  }\n  50% {\n    opacity: 1;\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
